import { type FetchSurveyBySurveyIdV2Data, type SurveyUserV2, useSettings } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { surveyApi } from '../api';

/**
 *  Returns one survey
 */
export const useSurveyByIdQuery = (surveyId: string) => {
	const { areSettingsLoading, settings } = useSettings();
	const { data, error, isError, isLoading, refetch } = useQuery<
		FetchSurveyBySurveyIdV2Data,
		unknown,
		SurveyUserV2 | undefined
	>({
		enabled: Boolean(surveyId && !areSettingsLoading && settings?.isPollEnabled),
		queryFn: async () =>
			(await surveyApi).fetchSurveyBySurveyIdV2({
				'details[]': [
					'surveyTranslations',
					'answerTranslations',
					'answerImages',
					'surveyImages',
					'partnerImages'
				],
				surveyId
			}),
		queryKey: ['survey', surveyId],
		select: res => res.data
	});

	return { data, error, isError, isLoading, refetch };
};
